/**
 * Tiny MCE Links Utils
 */

// Currently Tiny MCE does not support automatic class changes to existing buttons and links when editing buttons.js file. This script is meant to update existing links with new classes without the need to republish in the CMS editor.

export const updateLinkClasses = (component: HTMLElement | null = null) => {
    const tinyMceLinks = component?.querySelectorAll<HTMLElement>('[data-mce-button="true"][data-theme="btn--style-6"]')
    
    // Add classes in array as required
    const linkClassesArray = ['items-baseline']
    const linkTextClassesArray = ['underline', 'text-left']
    const linkIconClassesArray = ['relative', 'top-1']

    tinyMceLinks?.forEach((link) => {
        linkClassesArray.forEach((linkClass) => {
            link.classList.add(linkClass)
        });
        const linkTextEls = link.querySelectorAll('span')
        linkTextEls.forEach((span)=>{
            if (!span.children[0]?.classList.contains('icon')) {
                linkTextClassesArray.forEach((linkClass)=>{
                    if (!span?.classList.contains(linkClass)) {
                        span?.classList.add(linkClass) 
                    }
                })
            }else{
                linkIconClassesArray.forEach((linkClass)=>{
                    if (!span?.classList.contains(linkClass)) {
                        span?.classList.add(linkClass) 
                    }
                })
            }
        })
    })
}
